import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const LandngPage = () => {
  return (
    <>
      <Header />

      {/* <!--hero section start--> */}
      <section className="banner overflow-hidden">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 order-lg-1 ps-lg-8">
              <div className="banner-img animate__animated animate__fadeInRight animate__slow">
                <img
                  className="img-fluid"
                  src="./assets/images/banner/01.png"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 mt-10 mt-lg-0">
              <div className="animate__animated animate__shakeX animate__slow">
                <h6>
                  Welcome To <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </h6>
              </div>
              <h1 className="mb-4 animate__animated animate__shakeX animate__slow">
                Digital Marketing & SEO Experts
                <br />
                <span>Fox Media </span>
              </h1>
              <p className="lead mb-5 animate__animated animate__zoomIn animate__slow">
                Qatar’s trusted partner for driving online success. We
                specialize in Search Engine Optimization (SEO), Geo Targeting
                (GEO), Answer Engine Optimization (AEO), and innovative digital
                marketing strategies that help your business reach the right
                audience, at the right time, on the right platform.
              </p>
              <div className="d-sm-flex align-items-center animate__animated animate__fadeInUp animate__slow">
                <a className="themeht-btn primary-btn" href="#">
                  <span>Get Started</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
                <a
                  className="video-btn is-play popup-youtube ms-7"
                  href="https://www.youtube.com/watch?v=P_wKDMcr1Tg"
                >
                  <div className="video-btn-outer-circle has-scale-animation"></div>
                  <div className="video-btn-outer-circle has-scale-animation has-delay-short"></div>
                  <div className="video-btn-icon is-play">
                    <i className="flaticon flaticon-play"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="banner-shape">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 288 288"
          >
            <linearGradient
              id="bannerwave"
              x1="70.711%"
              x2="0%"
              y1="70.711%"
              y2="0%"
            >
              <stop className="stop-color1" offset="0%" stop-opacity="1" />
              <stop className="stop-color2" offset="100%" stop-opacity="1" />
            </linearGradient>
            <path fill="url(#bannerwave)">
              <animate
                repeatCount="indefinite"
                attributeName="d"
                dur="10s"
                values="M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
        c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
        c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
        c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z;
        
        
        M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4
        c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6
        c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8
        C48.9,198.6,57.8,191,51,171.3z;
        
        M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
        c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
        c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
        c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z  "
              />
            </path>
          </svg>
        </div>
      </section>
      {/* <!--hero section end--> */}

      {/* <!--body content start--> */}
      <div className="page-content">
        {/* <!--feature start--> */}
        <section className="pt-0">
          <div className="rocket-shade">
            <img
              className="img-fluid"
              src="./assets/images/shape-small-1.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row gx-5">
              <div className="col-lg-4 col-md-6">
                <div className="featured-item style-1 text-center">
                  <div className="featured-icon">
                    <img
                      className="img-fluid"
                      src="./assets/images/feature/01.png"
                      alt=""
                    />
                  </div>
                  <div className="featured-title">
                    <h4>SEO (Search Engine Optimization)</h4>
                  </div>
                  <div className="featured-desc">
                    <p>
                      Get high rankings with multi-team collaboration that will
                      help you optimize off-page SEO.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-6 mt-md-0">
                <div className="featured-item style-1 featured-active text-center">
                  <div className="featured-icon">
                    <img
                      className="img-fluid"
                      src="./assets/images/feature/02.png"
                      alt=""
                    />
                  </div>
                  <div className="featured-title">
                    <h4>AEO (Answer Engine Optimization)</h4>
                  </div>
                  <div className="featured-desc">
                    <p>
                      Get high rankings with multi-team collaboration that will
                      help you optimize off-page SEO.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-6 mt-lg-0">
                <div className="featured-item style-1 text-center">
                  <div className="featured-icon">
                    <img
                      className="img-fluid"
                      src="./assets/images/feature/03.png"
                      alt=""
                    />
                  </div>
                  <div className="featured-title">
                    <h4>GEO (Geographical SEO)</h4>
                  </div>
                  <div className="featured-desc">
                    <p>
                      Get high rankings with multi-team collaboration that will
                      help you optimize off-page SEO.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--feature end--> */}

        {/* <!--about start--> */}
        <section className="pt-0">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12">
                <div className="shape-img-bg">
                  <img
                    className="mask-img"
                    src="./assets/images/about/01.jpg"
                    alt=""
                  />
                  <div className="img-bg-shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      viewBox="0 0 288 288"
                    >
                      <linearGradient
                        id="imagewave"
                        x1="70.711%"
                        x2="0%"
                        y1="70.711%"
                        y2="0%"
                      >
                        <stop
                          className="stop-color2"
                          offset="0%"
                          stop-opacity="1"
                        />
                        <stop
                          className="stop-color1"
                          offset="100%"
                          stop-opacity="1"
                        />
                      </linearGradient>
                      <path fill="url(#imagewave)">
                        <animate
                          repeatCount="indefinite"
                          attributeName="d"
                          dur="5s"
                          values="M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
  c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
  c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
  c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z;
  
  
  M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4
  c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6
  c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8
  C48.9,198.6,57.8,191,51,171.3z;
  
  M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
  c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
  c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
  c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z  "
                        />
                      </path>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 mt-6 mt-lg-0 ps-lg-10">
                <div className="theme-title mb-4">
                  <h6>About Us</h6>
                  <h2>Qatar’s Leading Digital Marketing & SEO Experts </h2>
                  <p>
                    Welcome to Fox Media — Qatar’s trusted partner for driving
                    online success. We specialize in Search Engine Optimization
                    (SEO), Geo Targeting (GEO), Answer Engine Optimization
                    (AEO), and innovative digital marketing strategies that help
                    your business reach the right audience, at the right time,
                    on the right platform.
                  </p>
                  <p>
                    Our expert team combines local market knowledge with global
                    best practices to deliver measurable results. Whether you
                    want to dominate Google search rankings, target customers in
                    specific Qatar locations, or optimize for future AI-driven
                    searches, we’ve got you covered.
                  </p>
                </div>

                <a className="themeht-btn secondary-btn mt-5" href="#">
                  <span>Discover More</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* <!--about end--> */}

        {/* <!--service start--> */}
        <section className="pb-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="theme-title">
                  <h6>Services</h6>
                  <h2>Features Loved Our Digital Marketing Services!</h2>
                </div>
                <img
                  className="img-fluid"
                  src="./assets/images/about/02.png"
                  alt=""
                />
              </div>
              <div className="col-lg-7 ps-lg-8">
                <div className="row">
                  <div className="col-md-6">
                    <div className="service-item style-1">
                      <div className="service-item-inner">
                        <div className="service-icon">
                          <i className="flaticon flaticon-seo-3"></i>
                        </div>
                        <div className="service-desc">
                          <div className="service-title">
                            <h4>SEO Marketing</h4>
                          </div>
                          <p>
                            Our strategy includes consistently evolving, to
                            ensure we’re SEO for business. Get more traffic with
                            powerful SEO services.
                          </p>
                          <a className="arrow-btn" href="services-single.html">
                            <i className="bi bi-arrow-up-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mt-6">
                    <div className="service-item style-1 service-active">
                      <div className="service-item-inner">
                        <div className="service-icon">
                          <i className="flaticon flaticon-content-marketing"></i>
                        </div>
                        <div className="service-desc">
                          <div className="service-title">
                            <h4>Geo Targeting (GEO)</h4>
                          </div>
                          <p>
                            Our strategy includes consistently evolving, to
                            ensure we’re SEO for business. Get more traffic with
                            powerful SEO services.
                          </p>
                          <a className="arrow-btn" href="services-single.html">
                            <i className="bi bi-arrow-up-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mt-6 mt-md-0">
                    <div className="service-item style-1">
                      <div className="service-item-inner">
                        <div className="service-icon">
                          <i className="flaticon flaticon-digital-marketing"></i>
                        </div>
                        <div className="service-desc">
                          <div className="service-title">
                            <h4>Digital Marketing</h4>
                          </div>
                          <p>
                            Our strategy includes consistently evolving, to
                            ensure we’re SEO for business. Get more traffic with
                            powerful SEO services.
                          </p>
                          <a className="arrow-btn" href="services-single.html">
                            <i className="bi bi-arrow-up-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mt-6">
                    <div className="service-item style-1">
                      <div className="service-item-inner">
                        <div className="service-icon">
                          <i className="flaticon flaticon-email-2"></i>
                        </div>
                        <div className="service-desc">
                          <div className="service-title">
                            <h4>Answer Engine Optimization (AEO)</h4>
                          </div>
                          <p>
                            Our strategy includes consistently evolving, to
                            ensure we’re SEO for business. Get more traffic with
                            powerful SEO services.
                          </p>
                          <a className="arrow-btn" href="services-single.html">
                            <i className="bi bi-arrow-up-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--service end--> */}

        {/* <!--about start--> */}
        <section>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 order-lg-1">
                <div className="shape-img-bg">
                  <img
                    className="mask-img"
                    src="./assets/images/about/03.jpg"
                    alt=""
                  />
                  <div className="img-bg-shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      viewBox="0 0 288 288"
                    >
                      <linearGradient
                        id="imagewave2"
                        x1="70.711%"
                        x2="0%"
                        y1="70.711%"
                        y2="0%"
                      >
                        <stop
                          className="stop-color2"
                          offset="0%"
                          stop-opacity="1"
                        />
                        <stop
                          className="stop-color1"
                          offset="100%"
                          stop-opacity="1"
                        />
                      </linearGradient>
                      <path fill="url(#imagewave2)">
                        <animate
                          repeatCount="indefinite"
                          attributeName="d"
                          dur="5s"
                          values="M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
                c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
                c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
                c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z;
                
                
                M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4
                c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6
                c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8
                C48.9,198.6,57.8,191,51,171.3z;
                
                M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
                c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
                c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
                c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z  "
                        />
                      </path>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 mt-6 mt-lg-0 pe-lg-10">
                <div className="theme-title mb-4">
                  <h6>What We Do</h6>
                  <h2>Why Choose Us?</h2>
                  <p>
                    Your customers are searching for your products and services
                    every single day. We make sure they find you first. From
                    geo-focused campaigns in Doha to national SEO strategies, we
                    deliver growth, traffic, and conversions.
                  </p>
                </div>
                <div className="ht-progress-bar">
                  <div className="progress-parcent">
                    <span>99</span>%
                  </div>
                  <div className="flex-grow-1">
                    <h4>
                      Local Qatar Expertise – We understand the unique demands
                      of the Qatar market.
                    </h4>
                    <div className="progress" data-value="99">
                      <div className="progress-bar"></div>
                    </div>
                  </div>
                </div>
                <div className="ht-progress-bar">
                  <div className="progress-parcent">
                    <span>93</span>%
                  </div>
                  <div className="flex-grow-1">
                    <h4>
                      Data-Driven Results – Every campaign is monitored,
                      analyzed, and improved.
                    </h4>
                    <div className="progress" data-value="93">
                      <div className="progress-bar"></div>
                    </div>
                  </div>
                </div>
                <div className="ht-progress-bar">
                  <div className="progress-parcent">
                    <span>98</span>%
                  </div>
                  <div className="flex-grow-1">
                    <h4>
                      Future-Proof Strategies – From SEO to AEO, we prepare you
                      for evolving search technologies.
                    </h4>
                    <div className="progress" data-value="98">
                      <div className="progress-bar"></div>
                    </div>
                  </div>
                </div>

                <div className="ht-progress-bar">
                  <div className="progress-parcent">
                    <span>96</span>%
                  </div>
                  <div className="flex-grow-1">
                    <h4>
                      Transparent Reporting – Know exactly how your investment
                      is performing.
                    </h4>
                    <div className="progress" data-value="96">
                      <div className="progress-bar"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--about end--> */}
      </div>
      {/* <!--body content end-->  */}

      <Footer />

      {/* <!--back-to-top start--> */}
      <div className="scroll-top">
        <svg
          className="scroll-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
      {/* <!--back-to-top end--> */}
    </>
  );
};

export default LandngPage;
